import type { UserMinimal } from "@/entities/user";

import { useGetCurrentUser } from "./current-user.query";

export const useHasCurrentUser = (users?: UserMinimal[]): boolean => {
  const { currentUser } = useGetCurrentUser();

  return (users || []).some((user) => user.id === currentUser?.id);
};
